import type { MarketingPageContent } from '@/config/marketing-content/types'
import { MarketingCta } from '@/components/marketing/marketing-cta'
import { FaqSection } from '@/components/marketing/faq-section'
import { FeaturePillGrid } from '@/components/marketing/feature-pill-grid'
import { FeatureShowcase } from '@/components/marketing/feature-showcase'
import { HowItWorksSteps } from '@/components/marketing/how-it-works-steps'
import { MarketingHero } from '@/components/marketing/marketing-hero'

export function FeatureMarketingPage({ content }: { content: MarketingPageContent }) {
  return (
    <main>
      <MarketingHero
        eyebrow={content.eyebrow}
        title={content.heroTitle}
        lead={content.heroLead}
        heroImage={content.heroImage}
        heroImageMaxWidth={content.heroImageMaxWidth}
        className="marketing-hero--diagram-bleed"
      />

      {content.showcaseTitle ? (
        <FeatureShowcase
          kicker={content.eyebrow}
          title={content.showcaseTitle}
          lead={content.showcaseLead}
          imageSrc={content.showcaseImage}
          imageAlt={content.showcaseTitle}
          ctaLabel={content.ctaPrimaryLabel}
          ctaHref={content.ctaPrimaryHref}
        >
          {content.showcasePills ? <FeaturePillGrid pills={content.showcasePills} /> : null}
        </FeatureShowcase>
      ) : null}

      {content.steps && content.howItWorksTitle ? (
        <HowItWorksSteps
          kicker={content.howItWorksEyebrow}
          title={content.howItWorksTitle}
          lead={content.howItWorksLead}
          steps={content.steps}
        />
      ) : null}

      {content.featureShowcases?.map((showcase) => (
        <FeatureShowcase
          key={showcase.title}
          kicker={showcase.kicker}
          title={showcase.title}
          lead={showcase.lead}
          imageSrc={showcase.imageSrc}
          imageAlt={showcase.imageAlt}
          ctaLabel={showcase.ctaLabel}
          ctaHref={showcase.ctaHref}
        />
      ))}

      {content.faqItems && content.faqTitle ? (
        <FaqSection
          eyebrow={content.faqEyebrow}
          title={content.faqTitle}
          lead={content.faqLead}
          items={content.faqItems}
          variant="cards"
        />
      ) : null}

      {content.ctaTitle && content.ctaLead && content.ctaPrimaryLabel && content.ctaPrimaryHref ? (
        <MarketingCta
          title={content.ctaTitle}
          lead={content.ctaLead}
          primaryLabel={content.ctaPrimaryLabel}
          primaryHref={content.ctaPrimaryHref}
        />
      ) : null}
    </main>
  )
}
